import { createAction, props } from "@ngrx/store";
import { UserCreationRequest, UserData, UserSearchFilter } from "../../models/user.model";

export const userCreationRequest = createAction(
        '[User] User creation request', props<{ userCreationRequest: UserCreationRequest }>());

export const userCreationSuccess = createAction(
        '[User] User creation success');

export const userCreationFail = createAction(
        '[User] User creation fail', props<{ errorMessage: string }>());

export const userEdit = createAction(
        '[User] User edit', props<{ userToEdit: UserData }>());

export const userSearchRequest = createAction(
        '[User] User search request', props<{ searchFilter: UserSearchFilter }>());

export const userSearchAllRequest = createAction(
        '[User] User search all request');

export const userSearchSuccess = createAction(
        '[User] User search success', props<{ searchResult: UserData[] }>());

export const userSearchDataReset = createAction(
        '[User] User search data reset');

export const userSearchFail = createAction(
        '[User] User search fail', props<{ errorMessage: string }>());

export const userConfirmSignupRequest = createAction(
        '[User] User confirm signup request', props<{ email: string }>());

export const userConfirmSignupSuccess = createAction(
        '[User] User confirm signup success', props<{ email: string }>());

export const userConfirmSignupFail = createAction(
        '[User] User confirm signup fail', props<{ errorMessage: string }>());

export const userDeleteRequest = createAction(
        '[User] User delete request', props<{ userId: number }>());

export const userDeleteSuccess = createAction(
        '[User] User delete success', props<{ userId: number }>());

export const userDeleteFail = createAction(
        '[User] User delete fail', props<{ errorMessage: string }>());